const product = (state = {}, action) => {
  switch (action.type) {
    case 'UPDATE_PRODUCT':
      return action.product || {};
    default:
      return state;
  }
};
export default product;
